import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ValidarDocumentoService } from '../../services/validar-documento.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-validacion-documentos',
  templateUrl: './validacion-documentos.component.html',
  styleUrls: ['./validacion-documentos.component.scss']
})
export class ValidacionDocumentosComponent {
  archivoSeleccionado: File | null = null;
  vistaPreviaUrl: SafeResourceUrl | null = null;

  constructor(
    private validacionService: ValidarDocumentoService,
    private sanitizer: DomSanitizer,
    private toastService: ToastrService,
    private translate: TranslateService
  ) {}

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.archivoSeleccionado = input.files[0];

      // Validar tipo de archivo (solo PDF)
      if (this.archivoSeleccionado.type !== 'application/pdf') {
        this.toastService.error(
          this.translate.instant('validacion_documentos.error_tipo_archivo')
        );
        this.archivoSeleccionado = null;
        this.vistaPreviaUrl = null;
        return;
      }

      // Validar tamaño del archivo (máx. 25MB)
      if (this.archivoSeleccionado.size > 25 * 1024 * 1024) {
        this.toastService.error(
          this.translate.instant('validacion_documentos.error_archivo_tamano')
        );
        this.archivoSeleccionado = null;
        this.vistaPreviaUrl = null;
        return;
      }

      // Generar vista previa si es un archivo PDF o imagen
      const reader = new FileReader();
      reader.onload = () => {
        const unsafeUrl = reader.result as string;
        this.vistaPreviaUrl = this.sanitizer.bypassSecurityTrustResourceUrl(unsafeUrl);
      };
      reader.readAsDataURL(this.archivoSeleccionado);
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onFileDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();

    if (event.dataTransfer?.files.length) {
      const file = event.dataTransfer.files[0];
      this.archivoSeleccionado = file;

      // Validar tipo de archivo (solo PDF)
      if (this.archivoSeleccionado.type !== 'application/pdf') {
        this.toastService.error(
          this.translate.instant('validacion_documentos.error_tipo_archivo')
        );
        this.archivoSeleccionado = null;
        this.vistaPreviaUrl = null;
        return;
      }

      // Validar tamaño del archivo (máx. 25MB)
      if (this.archivoSeleccionado.size > 25 * 1024 * 1024) {
        this.toastService.error(
          this.translate.instant('validacion_documentos.error_archivo_tamano')
        );
        this.archivoSeleccionado = null;
        this.vistaPreviaUrl = null;
        return;
      }

      // Generar vista previa si es un archivo PDF o imagen
      const reader = new FileReader();
      reader.onload = () => {
        const unsafeUrl = reader.result as string;
        this.vistaPreviaUrl = this.sanitizer.bypassSecurityTrustResourceUrl(unsafeUrl);
      };
      reader.readAsDataURL(this.archivoSeleccionado);
    }
  }

  async validarArchivo(): Promise<void> {
    if (this.archivoSeleccionado) {
      try {
        const hash = await this.validacionService.generarHash(this.archivoSeleccionado);
        this.validacionService.validarHash(hash).subscribe((resultado) => {
          if (resultado) {
            this.toastService.success(
              this.translate.instant('validacion_documentos.validacion_exitosa')
            );
          } else {
            this.toastService.error(
              this.translate.instant('validacion_documentos.validacion_fallida')
            );
          }
        });
      } catch (error) {
        console.error('Error al generar el hash:', error);
        this.toastService.error(
          this.translate.instant('validacion_documentos.error_validacion')
        );
      }
    }
  }
}
